import type { MainMarketEventResult } from '@/interface/IMatch';
import { SportType, TimezoneOffset } from '@/interface/enum';
import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
import { getNowWithGMT, parseISOString } from '@/libraries/utils/date';

interface IMatchDisplayInfo {
    mainMarketEventResult: MainMarketEventResult;
    sportType: SportType;
}

export function getLiveDisplayTime(match: IMatchDisplayInfo | null) {
    if (!match) {
        return '';
    }

    if (match.sportType !== SportType.Soccer) {
        return '';
    }

    if (!match.mainMarketEventResult.extraInfo) {
        return getTranslationBySite('live');
    }

    const period = match.mainMarketEventResult.extraInfo.period;

    if (period <= 0) {
        return getTranslationBySite('live');
    }
    if (period === 5) {
        return 'HT';
    }

    const periodCurrentMinutes = getPeriodCurrentMinutes(match.mainMarketEventResult.extraInfo.periodStartTime);
    const quarter = period > 2 ? `${period - 2}E` : `${period}H`;
    const minutes = Math.min(Math.max(periodCurrentMinutes, 0), 99);
    return `${quarter} ${minutes}'`;
}

function getPeriodCurrentMinutes(periodStartTime: string) {
    if (periodStartTime === '0001-01-01T00:00:00') {
        return 0;
    }

    const sec = getNowWithGMT(TimezoneOffset.Server).getTime() - parseISOString(periodStartTime).getTime();
    return Math.floor(sec / (60 * 1000));
}
